import Vue from "vue";
import Router from "vue-router";
import index from "@/components/index";

Vue.use(Router);
//获取原型对象上的push函数
const originalPush = Router.prototype.push;
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const router = new Router({
  // mode: 'history',   // 去除路由中的 # 号
  routes: [
    {
      path: "/index",
      name: "index",
      redirect: "/new"
    },
    {
      path: "/",
      name: "new",
      redirect: "/home",
      component: index,
      children: [
        // {
        //     path: "/",
        //     name: "home",
        //     component: () => import("../components/home/home.vue")
        // },
        {
          path: "/",
          name: "home",
          component: () => import("../components/home/home.vue")
        },
        {
          path: "/new/privateMap",
          name: "privateMap",
          component: () =>
            import("../components/solution/privateMap.vue")
        },
        {
          path: "/new/solution",
          name: "solution",
          component: () =>
            import("../components/solution/solution.vue")
        },
        {
          path: "/new/product",
          name: "product",
          component: () =>
            import("../components/productCenter/product.vue")
        },
        {
          path: "/new/service",
          name: "service",
          component: () =>
            import("../components/serviceSupport/service.vue")
        },
        {
          path: "/new/introduce",
          name: "introduce",
          component: () =>
            import("../components/aboutUs/introduce.vue")
        },
        {
          path: "/new/history",
          name: "history",
          component: () => import("../components/aboutUs/history.vue")
        },
        {
          path: "/new/honor",
          name: "honor",
          component: () => import("../components/aboutUs/honor.vue")
        },
        {
          path: "/new/recruitment",
          name: "recruitment",
          component: () =>
            import("../components/aboutUs/recruitment.vue")
        }
      ]
    }
    // {
    //     path: "/index",
    //     name: "index",
    //     component: index,
    //     redirect: "/home",
    //     children: [
    //         {
    //             path: "/home",
    //             name: "home",
    //             component: () => import("../components/home/home.vue")
    //         },
    //         {
    //             path: "/solution",
    //             name: "solution",
    //             component: () =>
    //                 import("../components/solution/solution.vue")
    //         },
    //         {
    //             path: "/product",
    //             name: "product",
    //             component: () =>
    //                 import("../components/productCenter/product.vue")
    //         },
    //         {
    //             path: "/service",
    //             name: "service",
    //             component: () =>
    //                 import("../components/serviceSupport/service.vue")
    //         },
    //         {
    //             path: "/introduce",
    //             name: "introduce",
    //             component: () =>
    //                 import("../components/aboutUs/introduce.vue")
    //         },
    //         {
    //             path: "/history",
    //             name: "history",
    //             component: () => import("../components/aboutUs/history.vue")
    //         },
    //         {
    //             path: "/honor",
    //             name: "honor",
    //             component: () => import("../components/aboutUs/honor.vue")
    //         },
    //         {
    //             path: "/recruitment",
    //             name: "recruitment",
    //             component: () =>
    //                 import("../components/aboutUs/recruitment.vue")
    //         }
    //     ]
    // }
  ]
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js